import { render, staticRenderFns } from "./PhotographManage.vue?vue&type=template&id=a56ea56c&scoped=true&"
import script from "./PhotographManage.vue?vue&type=script&lang=js&"
export * from "./PhotographManage.vue?vue&type=script&lang=js&"
import style0 from "./PhotographManage.vue?vue&type=style&index=0&id=a56ea56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56ea56c",
  null
  
)

export default component.exports